import * as React from "react";
import {connect} from "react-redux";
import {IInReportGroup, InReportSummary} from "../../../model/product/inreports/InReportSummary.model";
import {InReportSummaryComponent} from "./InReportSummaryComponent";
import {getSuccessData, REQUEST_STATES, RequestState} from "../../common/commonStates";
import {ErrorComponent} from "../../base/Error.component";
import {mostRecentInReports} from "../../../../mainReducerMapSelectors";
import {FormattedMessage} from "react-intl";
import {IApplicationRootState} from "../../../../applicationState";

interface IInReportsRequesterPropsFromParent {
    productBackstopId: number;
}

interface IInReportsRequesterPropsFromStore {
    inReportGroup: RequestState<IInReportGroup>;
}

export type IInReportsRequesterProps = IInReportsRequesterPropsFromParent
    & IInReportsRequesterPropsFromStore;

export const IN_REPORTS_SUBTITLE = "Aon's expert insights to your investment decisions";

export const InReportsComponent: React.FunctionComponent<IInReportsRequesterProps> = (props) => {
    if (props.inReportGroup.kind === REQUEST_STATES.NOT_REQUESTED
        || props.inReportGroup.kind === REQUEST_STATES.REQUESTED) {
        return null;
    }

    if (props.inReportGroup.kind === REQUEST_STATES.REQUEST_FAILED) {
        return <ErrorComponent/>;
    }

    const inReportGroup = getSuccessData(props.inReportGroup);

    const renderHeader = () => {
        return  <div>
                    <h2 className="product__inreports-title">
                    <FormattedMessage
                        id="product.in-reports"
                        defaultMessage="InReports"
                    />
                </h2>
                <div className="product__inreports-subtitle">
                    <FormattedMessage id="product.in-reports-subtitle" defaultMessage={IN_REPORTS_SUBTITLE}/>
                </div>
         </div>;
    };

    if (!inReportGroup?.inBriefSummary && !inReportGroup?.inTotalSummary && !inReportGroup?.inFormSummary ) {
        return null;
    }

    return <div className="product__documents">
        {renderHeader()}
        {renderInReportComponent(inReportGroup?.inBriefSummary, "InBrief")}
        {renderInReportComponent(inReportGroup?.inTotalSummary, "InTotal")}
        {renderInReportComponent(inReportGroup?.inFormSummary, "InForm")}
    </div>;

    function renderInReportComponent(inReportSummary: InReportSummary | undefined | null, linkName: string) {
        if (!inReportSummary) {
            return null;
        }

        return <InReportSummaryComponent
            productBackstopId={props.productBackstopId}
            inReportSummary={inReportSummary}
            linkName={linkName}/>;
    }
};

export const mapStateToProps = (store: IApplicationRootState): IInReportsRequesterPropsFromStore => {
    return {
        inReportGroup: mostRecentInReports(store),
    };
};

const connector = connect<IInReportsRequesterPropsFromStore, {}, {}, IApplicationRootState>(
    mapStateToProps,
);

const connectedComponent = connector(InReportsComponent);
export default connectedComponent;
